import { render, staticRenderFns } from "./specifications.vue?vue&type=template&id=338ca468"
import script from "./specifications.vue?vue&type=script&lang=js"
export * from "./specifications.vue?vue&type=script&lang=js"
import style0 from "./specifications.vue?vue&type=style&index=0&id=338ca468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports